export enum PrioritizeRequestStatus {
    None = "None",
    InProgress = "InProgress",
    Ready = "Ready",
    Error = "Error",
    Nudged = "Nudged"
}
